import React from "react";
import type { WrapRootElementBrowserArgs } from "gatsby";

import { AgentProvider } from "./components/agent/AgentContext";

/**
 * Everything that must outlive a page change.
 *
 * Gatsby unmounts the whole page tree on a client-side navigation. The agent
 * provider used to sit inside `Layout`, which every page renders, so opening
 * the agent, asking something and then clicking a nav link threw away the
 * messages, the session and the in-flight stream - the conversation simply
 * vanished mid-answer.
 *
 * `wrapRootElement` is mounted once, above the router, and is not re-created
 * between routes. Note it also runs during SSR (via gatsby-ssr), so nothing in
 * here may touch `window` at module scope.
 */
export const wrapRootElement = ({ element }: WrapRootElementBrowserArgs) => (
  <AgentProvider>{element}</AgentProvider>
);
